export { default } from './NumberCalls.container'



// WEBPACK FOOTER //
// ./src/pages/NumberCalls/index.js